import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'aw-section-header-actions',
  standalone: true,
  templateUrl: './section-header-actions.component.html',
})
export class SectionHeaderActionsComponent {}
